import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import { Component, Output, Input, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { MdIconModule } from '@angular/material';

import 'rxjs/add/observable/of';
// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { NgxPageSize, NgxRefresh, NgxToggleColumn } from '../../shared/index';
import { CommonService, ServiceWalkInService, SubscribeService } from '../../services/index';
import { ServiceWalkInModel } from '../../model/index';
import { AddServiceClientComponent } from '../transaction/serviceWalkIn/addServiceClient.component';
import { AddEditClientComponent } from '../master/client/addEditClient.component';

@Component({
    selector: 'client-servicesearch',
    templateUrl: './clientServiceSearch.component.html',
})
export class ClientServiceSearchComponent {
    @Input() query = '';
    @Input() searching = false;
    @Input() ishideButton;
    @Input() set initialLoad(val: boolean) {
        this.iniLoadFn(val);
    }
    @Output() clientSearchEmit = new EventEmitter();
    @Output() saveServiceResponse = new EventEmitter();
    //@Output() search = new EventEmitter<string>();
    private searchTerms = new Subject<string>();
    searchVal = '';
    searchLoc = '';
    columns = [];

    filteredItems: Observable<ServiceWalkInModel[]>;

    gridList = [];
    searchTerm$ = new Subject<string>();

    page = {
        limit: 50,
        count: 10,
        offset: 0,
        orderBy: 'client_id',
        orderDir: 'desc',
        type: '',
        query: ''
    };

    constructor(private commonService: CommonService,
        private modalService: BsModalService, public subscribeService: SubscribeService) {
        this.loadClientSerGridList();
    }

    ngOnInit(): void {
        this.columns = [
            { name: 'Client ID', prop: 'client_no', width: 100, maxWidth: 120, toggle: true },
            { name: 'Name', prop: 'client_name', maxWidth: 150 },
            { name: 'D.O.B', prop: 'disp_dob', maxWidth: 100 },
            { name: 'Age', prop: 'age', maxWidth: 60 },
            { name: 'Address', prop: 'address', maxWidth: 150 },
            { name: 'Area', prop: 'area', maxWidth: 150 },
            { name: 'City', prop: 'city', maxWidth: 100 },
            { name: 'Mobile', prop: 'mobile', maxWidth: 115 }
        ];

        //this.toggleCol = Object.assign({}, this.columns);
    }
    iniLoadFn(initialLoad) {
        if (initialLoad == true) {
            this.searchTerm$.next('');
        }
    }

    loadClientSerGridList() {
        let that = this;
        this.commonService.servicesearch(this.searchTerm$, this.page)
            .subscribe(results => {
                that.gridList = results.data;
                that.page.count = results.totCnt;
            });
    }

    setType(type: string){
        this.page.type = type;
    }


    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.loadClientSerGridList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.loadClientSerGridList();
    }
    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }
    search(query: string) {
        this.searchTerms.next(query);
    }
    bsModalRef: BsModalRef;

    //ON CLICK NEW CLIENT BUTTON
    onclickNewClient(mode: string, row: any): void {
        let that = this;
        if (mode == "Add") {
            row = {
                mode: 'Add'
            }
            this.bsModalRef = this.modalService.show(AddServiceClientComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg maxWidthPer-80'
            });
            this.bsModalRef.content.title = 'Add New Service Client Details';
            this.bsModalRef.content.serviceClient = Object.assign({}, row);
            this.bsModalRef.content.resObj$.subscribe(res => {
                that.saveServiceResponse.emit(res);
            });
        }

    }


    /*onclickNewClient(mode: string, row: any): void {

        let that = this;
        

        if (mode == "Add") {
            row = {
               
                'mode': mode
            };
        }

        that.subscribeService.subScribeTabID('Transaction', 'AddServiceClientComponent', row, this['params']['tabParams']);
    }*/

    // ON ADD NEW CLIENT ENTRY
    onClickNewClientEntry() {
        let row = {
            mode: 'Add'
        }
        this.bsModalRef = this.modalService.show(AddEditClientComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg compWidth-90'
        });
        this.bsModalRef.content.title = 'Add New Client Details';
        this.bsModalRef.content.clientdata = Object.assign({}, row);

    }

    onSelectCustomer($event, row) {
        $('.client-search-list a').removeClass('active');
        $event.currentTarget.classList.add('active');

        this.clientSearchEmit.emit(row);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/clientServiceSearch.component.ts